module.exports = __webpack_public_path__ + "img/placeholder.305b5bca.svg";